// axios
import axios from 'axios'

let temp;
if (process.env.NODE_ENV == "development") {
  temp = process.env.VUE_APP_API_BASE_DEVELOPMENT_URL;
} else {
  temp = process.env.VUE_APP_API_BASE_URL;
}

let endpointStorage = localStorage.getItem('endpoint');
if (endpointStorage != null && endpointStorage != '') {
  temp = endpointStorage;
}
let clientId = localStorage.getItem('domainId');
if (clientId == null) {
  clientId = '';
}

export const domain = temp;
export const client_id = clientId;

export default axios.create({
  baseURL: domain,
  headers: {
    'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
    'G-ClientID': clientId,
  }
})
